/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DismissModel } from './DismissModel';
import {
    DismissModelFromJSON,
    DismissModelFromJSONTyped,
    DismissModelToJSON,
} from './DismissModel';
import type { PetConfigV2MetadataModel } from './PetConfigV2MetadataModel';
import {
    PetConfigV2MetadataModelFromJSON,
    PetConfigV2MetadataModelFromJSONTyped,
    PetConfigV2MetadataModelToJSON,
} from './PetConfigV2MetadataModel';
import type { PetFormConfigurationResponseEventModel } from './PetFormConfigurationResponseEventModel';
import {
    PetFormConfigurationResponseEventModelFromJSON,
    PetFormConfigurationResponseEventModelFromJSONTyped,
    PetFormConfigurationResponseEventModelToJSON,
} from './PetFormConfigurationResponseEventModel';
import type { PetV2FormActionModel } from './PetV2FormActionModel';
import {
    PetV2FormActionModelFromJSON,
    PetV2FormActionModelFromJSONTyped,
    PetV2FormActionModelToJSON,
} from './PetV2FormActionModel';
import type { PetV2FormSectionModel } from './PetV2FormSectionModel';
import {
    PetV2FormSectionModelFromJSON,
    PetV2FormSectionModelFromJSONTyped,
    PetV2FormSectionModelToJSON,
} from './PetV2FormSectionModel';

/**
 * 
 * @export
 * @interface PetV2FormConfigurationResponseModel
 */
export interface PetV2FormConfigurationResponseModel {
    /**
     * 
     * @type {PetConfigV2MetadataModel}
     * @memberof PetV2FormConfigurationResponseModel
     */
    metadata: PetConfigV2MetadataModel;
    /**
     * 
     * @type {DismissModel}
     * @memberof PetV2FormConfigurationResponseModel
     */
    dismiss: DismissModel;
    /**
     * 
     * @type {Array<PetV2FormSectionModel>}
     * @memberof PetV2FormConfigurationResponseModel
     */
    sections: Array<PetV2FormSectionModel>;
    /**
     * 
     * @type {PetV2FormActionModel}
     * @memberof PetV2FormConfigurationResponseModel
     */
    actions: PetV2FormActionModel;
    /**
     * 
     * @type {PetFormConfigurationResponseEventModel}
     * @memberof PetV2FormConfigurationResponseModel
     */
    event: PetFormConfigurationResponseEventModel;
}

/**
 * Check if a given object implements the PetV2FormConfigurationResponseModel interface.
 */
export function instanceOfPetV2FormConfigurationResponseModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "metadata" in value;
    isInstance = isInstance && "dismiss" in value;
    isInstance = isInstance && "sections" in value;
    isInstance = isInstance && "actions" in value;
    isInstance = isInstance && "event" in value;

    return isInstance;
}

export function PetV2FormConfigurationResponseModelFromJSON(json: any): PetV2FormConfigurationResponseModel {
    return PetV2FormConfigurationResponseModelFromJSONTyped(json, false);
}

export function PetV2FormConfigurationResponseModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PetV2FormConfigurationResponseModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'metadata': PetConfigV2MetadataModelFromJSON(json['metadata']),
        'dismiss': DismissModelFromJSON(json['dismiss']),
        'sections': ((json['sections'] as Array<any>).map(PetV2FormSectionModelFromJSON)),
        'actions': PetV2FormActionModelFromJSON(json['actions']),
        'event': PetFormConfigurationResponseEventModelFromJSON(json['event']),
    };
}

export function PetV2FormConfigurationResponseModelToJSON(value?: PetV2FormConfigurationResponseModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'metadata': PetConfigV2MetadataModelToJSON(value.metadata),
        'dismiss': DismissModelToJSON(value.dismiss),
        'sections': ((value.sections as Array<any>).map(PetV2FormSectionModelToJSON)),
        'actions': PetV2FormActionModelToJSON(value.actions),
        'event': PetFormConfigurationResponseEventModelToJSON(value.event),
    };
}

